module.exports = __webpack_public_path__ + "img/slider6.6c8e8cd9.jpg";